module.exports = "/_next/static/images/Embed@2x-db314ea0852f89e1d4b356046388ef4c.png";